import React, { useState } from "react";
import Layout from "../components/Layout";
import StuTable from "../components/StuTable";
import InvigilationProvider from "../context";
import useRequest from "../../../../utils/useRequest";
import { getExamStudentSubmitPaperList } from "../../../../service/exam";
import AsideSubmitted from "./components/AsideSubmitted";
import { isTrue } from "../../../../service/service";
import { ColumnProps } from "antd/lib/table/interface";
import moment from "moment";

export default function Submitted() {
    const [examId, setExamId] = useState("");
    const [studentName, setStudentName] = useState("");

    const [data, { loading }, refresh] = useRequest(
        () => getExamStudentSubmitPaperList({ studentName, examId }),
        {},
        [examId, studentName]
    );

    const columns: ColumnProps<any>[] = [
        {
            title: "打开试卷时间",
            dataIndex: "firstStartTime",
            align: "center",
            width: 100,
            render: time => time && moment(time).format("MM-DD HH:mm")
        },
        // {
        //     title: "提交试卷时间",
        //     dataIndex: "submitTime",
        //     align: "center",
        //     width: 100,
        //     render: time => time && moment(time).format("MM-DD HH:mm")
        // },
        {
            title: "提交状态",
            dataIndex: "submitStatus",
            align: "center",
            width: 70,
            render: examFlag => (isTrue(examFlag) ? "已提交" : "未提交")
        },
        {
            title: "附件数量",
            dataIndex: "uploadFileNum",
            align: "center",
            width: 70
        }
    ];

    return (
        <InvigilationProvider
            examId={examId}
            setExamId={setExamId}
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}>
            <Layout
                title="已交卷考生列表"
                refresh={refresh}
                table={
                    <StuTable
                        columns={columns}
                        onErrChange={refresh}
                        dataSource={data?.dataList || []}
                        loading={loading}
                    />
                }
                aside={<AsideSubmitted />}
                onSearch={setStudentName}
            />
        </InvigilationProvider>
    );
}
